import * as React from 'react';
import { Query } from 'react-apollo';

import gql from 'graphql-tag';

import type {
  GetDegreeHomeCalendarRequest,
  GetDegreeHomeCalendarResponse,
} from '@coursera/grpc-types-degreehome/coursera/proto/degreehome/v1beta1/degree_home_calendar_api';

/* eslint-disable graphql/template-strings */
export const getDegreeHomeCalendarQuery = gql`
  query GetDegreeHomeCalendar($input: DataMap!) {
    GetDegreeHomeCalendar(input: $input)
      @rest(
        type: "GetDegreeHomeCalendar"
        path: "grpc/degreehome/v1beta1/DegreeHomeCalendarAPI/GetDegreeHomeCalendar"
        method: "POST"
      ) {
      calendarItems
    }
  }
`;
/* eslint-enable */

export type DegreeHomeCalendarProps = Pick<GetDegreeHomeCalendarRequest, 'userId' | 'degreeId'> & {
  children: ({ loading, data, error, refetch, networkStatus }: $TSFixMe) => React.ReactElement | null;
};

export type QueryProps = {
  input: GetDegreeHomeCalendarRequest;
};

export const WithGetDegreeHomeCalendarQuery = ({ children, userId, degreeId }: DegreeHomeCalendarProps) => (
  <Query<GetDegreeHomeCalendarResponse, QueryProps>
    query={getDegreeHomeCalendarQuery}
    variables={{
      input: {
        userId,
        degreeId,
      },
    }}
    notifyOnNetworkStatusChange={true}
  >
    {({ loading, data, error, refetch }) => {
      return children({ loading, data, error, refetch });
    }}
  </Query>
);

export default WithGetDegreeHomeCalendarQuery;
